// shared-components/ui/Card.jsx
import PropTypes from "prop-types";
import { cn } from "@shared/lib/utils";
import { useSiteGradients } from "@shared/hooks";

const Card = ({
  className,
  children,
  hover = true,
  gradient = false,
  gradientType = null,
  animation = null,
  style = {},
  ...props
}) => {
  // Always call hooks unconditionally
  const siteGradients = useSiteGradients();
  const gradients =
    gradient || gradientType || animation ? siteGradients : null;

  // Determine gradient class
  let bgClass = "bg-white dark:bg-gray-800"; // Default background
  let animationClass = "";
  let cardStyle = { ...style };

  if (gradient || gradientType) {
    const gradientClass =
      gradientType && gradients[gradientType]
        ? gradients[gradientType]
        : gradients?.card || "";

    bgClass = gradientClass;

    // Add animation if specified
    if (animation && gradients?.animations?.[animation]) {
      animationClass = gradients.animations[animation];

      // Add inline animation style for consistent behavior
      if (animation === "goldenPulse") {
        cardStyle.animation =
          "pulse 1.618s cubic-bezier(0.618, 0, 0.382, 1) infinite";
      } else if (animation === "goldenSpin") {
        cardStyle.animation = "spin 16.18s linear infinite";
      } else if (animation === "specialPulse") {
        cardStyle.animation = "pulse 3s ease infinite";
      } else if (animation === "specialSpin") {
        cardStyle.animation = "spin 10.8s linear infinite";
      }
    }
  }

  // Hover effect
  const hoverClass = hover
    ? "transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
    : "";

  return (
    <div
      className={cn(
        "rounded-lg shadow-md overflow-hidden",
        bgClass,
        animationClass,
        hoverClass,
        className,
      )}
      style={cardStyle}
      {...props}
    >
      <div className="p-6">{children}</div>
    </div>
  );
};

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  hover: PropTypes.bool,
  gradient: PropTypes.bool,
  gradientType: PropTypes.string,
  animation: PropTypes.string,
  style: PropTypes.object,
};

export default Card;
export { Card };
